(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorModalidadController', ProyectosAprobadosPorModalidadController);

    ProyectosAprobadosPorModalidadController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorModalidadController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedAmbito = sSAmbitos[0];
        });
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorModalidad(
                vm.selectedSSPeriodo.id,
                vm.selectedSSAmbito,
                vm.selectedCentroDocente.id
            ).then(function () {
            	console.log("DONE");
            }).catch(function () {
            });
        }
    }
})();
